import {
	FCM_CAMPAIGN_ACTIONS_PAGE_CONFIG,
	FCM_COFFEE_GEO_PROFILE_QUALITY,
	FCM_COPY_LINK_ON_UNSIGNED,
	FCM_DECISION_MAKERS_LEGISLATIVE_BODIES,
	FCM_DISABLE_GEOLOCATION_GUEST_SIGN_FORM,
	FCM_DM_STATUS,
	FCM_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED,
	FCM_DOUBLE_OPT_IN_ENABLED,
	FCM_ENABLE_PETITION_STRENGTH_TIPS,
	FCM_GDPR_SIGN_OPT_IN,
	FCM_GDPR_SIGN_OPT_IN_COPY,
	FCM_HIDE_SIGNEES,
	FCM_PETITION_DISPLAY_RECRUITER_NAME,
	FCM_PETITION_PAGE_CONTACT_DM,
	FCM_PETITION_PAGE_NEWLY_CREATED_PETITIONS,
	FCM_PETITION_PAGE_TOP_SUPPORTERS,
	FCM_PETITION_SHOW_DISPLAY_CHAT_DAYS_POST_PUBLISH,
	FCM_PETITION_STARTER_MEDIA_INQUIRY_CONFIG,
	FCM_PETITIONS_MEDIA_HITS_CONFIG,
	FCM_PSF_REASON_FOR_SIGNING,
	FCM_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED,
	FCM_SAP_CTA_ON_PETITION_SHOW,
	FCM_SIGN_INTENT_VALID_SAMPLE_RATE,
	FCM_SIGN_VALIDATION_ERROR_SAMPLE_RATE,
	FCM_SIGNATURE_THERMOMETER,
	FCM_SIGNATURES_DISTRIBUTION_CONFIG,
	FCM_STARFISH_STARTER_DM_RECOMMENDER,
	FCM_SUPPORTER_SHARE_VISUALS,
} from '@change-corgi/fcm/configs';

export const configs = {
	sapCtaEnabled: FCM_SAP_CTA_ON_PETITION_SHOW,
	unsignedCopyLinkEnabled: FCM_COPY_LINK_ON_UNSIGNED,
	signeesHidden: FCM_HIDE_SIGNEES,
	statsTopSupportersEnabled: FCM_PETITION_PAGE_TOP_SUPPORTERS,
	statsRecruiterNameEnabled: FCM_PETITION_DISPLAY_RECRUITER_NAME,
	signValidationErrorTrackSampleRate: FCM_SIGN_VALIDATION_ERROR_SAMPLE_RATE,
	signValidationIntentValidTrackSampleRate: FCM_SIGN_INTENT_VALID_SAMPLE_RATE,
	storeReasonForSigning: FCM_PSF_REASON_FOR_SIGNING,
	chatDisplayDaysPostPublish: FCM_PETITION_SHOW_DISPLAY_CHAT_DAYS_POST_PUBLISH,
	suggestedVictoriousPetitionsEnabled: FCM_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED,
	strengthTipsEnabled: FCM_ENABLE_PETITION_STRENGTH_TIPS,
	campaignActionsPageConfig: FCM_CAMPAIGN_ACTIONS_PAGE_CONFIG,
	petitionsMediaHitsConfig: FCM_PETITIONS_MEDIA_HITS_CONFIG,
	signaturesDistributionConfig: FCM_SIGNATURES_DISTRIBUTION_CONFIG,
	starfishStarterDmRecommender: FCM_STARFISH_STARTER_DM_RECOMMENDER,
	contactDMConfig: FCM_PETITION_PAGE_CONTACT_DM,
	geolocGuestDisabled: FCM_DISABLE_GEOLOCATION_GUEST_SIGN_FORM,
	geoFieldsEnabled: FCM_COFFEE_GEO_PROFILE_QUALITY,
	gdprOptInEnabled: FCM_GDPR_SIGN_OPT_IN,
	gdprOptInCopy: FCM_GDPR_SIGN_OPT_IN_COPY,
	doubleOptInEnabled: FCM_DOUBLE_OPT_IN_ENABLED,
	newlyCreatedPetitionsEnabled: FCM_PETITION_PAGE_NEWLY_CREATED_PETITIONS,
	dmStatusConfig: FCM_DM_STATUS,
	petitionStarterMediaInquiryConfig: FCM_PETITION_STARTER_MEDIA_INQUIRY_CONFIG,
	signatureThermometerEnabled: FCM_SIGNATURE_THERMOMETER,
	shareVisualsEnabled: FCM_SUPPORTER_SHARE_VISUALS,
	decisionMakersLegislativeBodiesEnabled: FCM_DECISION_MAKERS_LEGISLATIVE_BODIES,
	dmWithLegislativeBodiesConnectionEnabled: FCM_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED,
};
